export const getCurrencySymbol = (currency: string) => {
  switch (currency) {
    case "usd":
      return "$";

    default:
      return "$";
  }
};
